import { Platform } from "react-native";

if (Platform.OS === "web") {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  require("get-root-node-polyfill/implement");
}
